var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBobaDonatorLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4535102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1122 9.65618C17.1122 8.63471 16.911 7.62325 16.52 6.67959C16.1291 5.73594 15.5561 4.87858 14.8338 4.15652C14.1116 3.43445 13.2541 2.86183 12.3105 2.47136C11.3669 2.08089 10.3556 1.88024 9.33447 1.88086C7.27296 1.88086 5.29588 2.70004 3.83817 4.1582C2.38046 5.61635 1.56152 7.59404 1.56152 9.65618H17.1122Z",
    fill: "#E3E7F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.2255 0.772152C10.2255 0.526114 9.92711 0.32666 9.55903 0.32666C9.19096 0.32666 8.89258 0.526114 8.89258 0.772152V9.87801C8.89258 10.124 9.19096 10.3235 9.55903 10.3235C9.92711 10.3235 10.2255 10.124 10.2255 9.87801V0.772152Z",
    fill: "#CED8ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.1188 8.76978H1.77592C1.28914 8.76978 0.894531 9.16762 0.894531 9.65839C0.894531 10.1492 1.28914 10.547 1.77592 10.547H17.1188C17.6056 10.547 18.0002 10.1492 18.0002 9.65839C18.0002 9.16762 17.6056 8.76978 17.1188 8.76978Z",
    fill: "#CBD3E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.78224 1.92059C9.26243 1.85577 9.74863 1.87033 10.225 1.96378V8.76757H8.66992C8.66992 8.76757 8.83839 1.92059 8.78224 1.92059Z",
    fill: "#E3E7F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.36704 6.76807C9.12217 6.76122 8.88667 6.66491 8.699 6.49487C8.68986 6.48616 8.68254 6.47546 8.67752 6.46346C8.67251 6.45147 8.66992 6.43845 8.66992 6.42529C8.66992 6.41212 8.67251 6.39911 8.67752 6.38712C8.68254 6.37512 8.68986 6.36441 8.699 6.3557C8.70749 6.3457 8.71781 6.33772 8.72931 6.33226C8.74081 6.3268 8.75324 6.32397 8.76581 6.32397C8.77837 6.32397 8.79079 6.3268 8.80229 6.33226C8.81379 6.33772 8.82412 6.3457 8.83261 6.3557C8.97073 6.49226 9.15117 6.56799 9.33841 6.56799C9.52564 6.56799 9.70609 6.49226 9.84421 6.3557C9.8527 6.3457 9.86303 6.33772 9.87453 6.33226C9.88603 6.3268 9.89845 6.32397 9.91101 6.32397C9.92358 6.32397 9.936 6.3268 9.9475 6.33226C9.959 6.33772 9.96932 6.3457 9.97782 6.3557C9.99391 6.37471 10.0028 6.39953 10.0028 6.42529C10.0028 6.45104 9.99391 6.47586 9.97782 6.49487C9.89911 6.58366 9.80417 6.6538 9.69902 6.70083C9.59387 6.74786 9.48082 6.77076 9.36704 6.76807Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.11637 7.43562C6.79117 7.43562 7.3382 6.88858 7.3382 6.21378C7.3382 5.53898 6.79117 4.99194 6.11637 4.99194C5.44157 4.99194 4.89453 5.53898 4.89453 6.21378C4.89453 6.88858 5.44157 7.43562 6.11637 7.43562Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M4.89453 6.1027C4.89453 5.80811 5.01131 5.52558 5.21918 5.31728C5.42704 5.10897 5.70897 4.99194 6.00294 4.99194C6.29735 4.99194 6.57976 5.10881 6.78838 5.31699C6.99699 5.52516 7.11481 5.80768 7.11605 6.1027",
    fill: "#51260E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M6.22744 6.10425C6.22744 6.281 6.15723 6.45051 6.03225 6.57549C5.90726 6.70047 5.73775 6.77069 5.56099 6.77069C5.4733 6.77132 5.38635 6.75452 5.30521 6.72125C5.22407 6.68798 5.15035 6.63892 5.08834 6.57691C5.02632 6.5149 4.97725 6.44117 4.94399 6.36003C4.91072 6.27889 4.89392 6.19194 4.89455 6.10425",
    fill: "#47220D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M12.892 7.43562C13.5055 7.43562 14.0028 6.88858 14.0028 6.21378C14.0028 5.53898 13.5055 4.99194 12.892 4.99194C12.2786 4.99194 11.7812 5.53898 11.7812 6.21378C11.7812 6.88858 12.2786 7.43562 12.892 7.43562Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M11.5576 6.1027C11.559 5.80768 11.6886 5.52516 11.9181 5.31699C12.1475 5.10881 12.4582 4.99194 12.782 4.99194C13.1054 4.99194 13.4155 5.10897 13.6442 5.31728C13.8728 5.52558 14.0013 5.80811 14.0013 6.1027",
    fill: "#51260E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M13.1127 6.10425C13.1127 6.281 13.0308 6.45052 12.8849 6.5755C12.7391 6.70049 12.5414 6.7707 12.3352 6.7707C12.1289 6.7707 11.9312 6.70049 11.7854 6.5755C11.6395 6.45052 11.5576 6.281 11.5576 6.10425",
    fill: "#47220D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBobaDonatorLogin);
export default __webpack_public_path__ + "static/media/boba-donator-login.c3aa77d4.svg";
export { ForwardRef as ReactComponent };